export default __webpack_public_path__ + "static/media/CardTitleAgenda.5d8dcaf3.svg";